import React from 'react';
import { Box, HStack, Icon, Text, Wrap, WrapItem } from '@chakra-ui/react';
import { BsPerson, IoBedOutline, IoResize } from 'react-icons/all';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { solid, regular, brands } from '@fortawesome/fontawesome-svg-core/import.macro';

export interface HardFactsProps {
  maximumPersons: number;
  sizeQm: string;
  numberOfBedrooms: number;
  numberOfPets: number;
}
export const HardFacts = (props: HardFactsProps): JSX.Element => {
  const { maximumPersons, sizeQm, numberOfBedrooms, numberOfPets } = props;
  //           {maximumPersons > 0 ? maximumPersons : '&infin;'} Gäste
  return (
    <HStack alignItems={'flex-start'} spacing={{base: 0, md:4}} flexWrap={'wrap'} h={{ base: 10, md: 8 }}>
      <Box flexDirection={'row'} display={'flex'} alignItems={'center'} mr={{base: 4, md:0}}>
        <Icon as={BsPerson} color={'gray.400'} fontSize={'xl'} mr={2} />
        <Text
          color={'gray.500'}
          fontSize={'sm'}
          dangerouslySetInnerHTML={{
            __html: maximumPersons === 1 ? `${maximumPersons} Gast` : `${maximumPersons} Gäste`,
          }}
        />
      </Box>
      <Box flexDirection={'row'} display={'flex'} alignItems={'center'} mr={{base: 4, md:0}}>
        <Icon as={IoResize} color={'gray.400'} fontSize={'xl'} mr={2} />
        <Text color={'gray.500'} fontSize={'sm'}>
          {sizeQm} m²
        </Text>
      </Box>
      <Box flexDirection={'row'} display={'flex'} alignItems={'center'} ms={0} mr={{base: 4, md:0}}>
        <Icon as={IoBedOutline} color={'gray.400'} fontSize={'xl'} mr={2} />
        <Text color={'gray.500'} fontSize={'sm'}>
          {numberOfBedrooms} Schlafz.
        </Text>
      </Box>
      <Box flexDirection={'row'} display={'flex'} alignItems={'center'} ms={0} mr={{base: 4, md:0}}>
        <Text color={'gray.500'} fontSize={'sm'}>
              <FontAwesomeIcon icon={solid("dog")} /> {numberOfPets > 0 ? 'Erlaubt' : 'Nein'}
        </Text>
      </Box>
    </HStack>
  );
};
